<div class="container">
  <mat-tab-group>
    <!-- Carriers Tab -->
    <mat-tab label="Carriers">
      <ng-container>
        <!-- table  -->
        <table mat-table [dataSource]="dataSource" *ngIf="(columnSetupReady$ | async)" matSort class="mat-elevation-z8" multiTemplateDataRows>
          <ng-container matColumnDef="color">
            <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
            <td mat-cell *matCellDef="let element" class="color-icon">
              <app-icon name="circle" [ngStyle]="{color: element.color}"></app-icon></td>
          </ng-container>

          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
            <td mat-cell *matCellDef="let element">
              {{element.name}} </td>
          </ng-container>

          <ng-container matColumnDef="startTime">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Start Time </th>
            <td mat-cell *matCellDef="let element">{{element.defaults.startTime | date:'h:mm a'}}</td>
          </ng-container>

          <ng-container matColumnDef="endTime">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> End Time </th>
            <td mat-cell *matCellDef="let element">
              {{element.defaults.endTime | date:'h:mm a'}} </td>
          </ng-container>

          <ng-container matColumnDef="number_of_staff">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Staff </th>
            <td mat-cell *matCellDef="let element">
              {{element.number_of_staff}} </td>
          </ng-container>
  
          <ng-container matColumnDef="installed_on_truck">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Installer </th>
            <td mat-cell *matCellDef="let element">
              {{element.installed_on_truck}} </td>
          </ng-container>

          <ng-container *ngIf="(featureFlags$ | async).virtualCarrier" matColumnDef="virtual">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Virtual </th>
            <td mat-cell *matCellDef="let element">
              {{element.virtual}} </td>
          </ng-container>

          <ng-container matColumnDef="max_weight">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Max Weight (lbs) </th>
            <td mat-cell *matCellDef="let element">
              {{element.max_weight}} </td>
          </ng-container>   

          <ng-container matColumnDef="cubic_feet">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Capacity (cuft) </th>
            <td mat-cell *matCellDef="let element">
              {{element.cubic_feet}} </td>
          </ng-container>

          <ng-container matColumnDef="priority">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Priority </th>
            <td mat-cell *matCellDef="let element">
              {{element.priority}} </td>
          </ng-container>

          <ng-container matColumnDef="userId">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> User </th>
            <td mat-cell *matCellDef="let element">
              <app-icon *ngIf="element.userId" name="person"></app-icon> </td>
          </ng-container>
          
          <ng-container matColumnDef="active">
            <th mat-header-cell *matHeaderCellDef> Actions </th>
            <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()">
              <div class="actions" *ngIf="!element.locked">
                <app-icon title="edit" class="pencil-icon" size="15" name="pencil" (click)="edit(element)"></app-icon>
                <app-icon title="clone" size="15" name="clone" (click)="clone(element)"></app-icon>
                <app-icon title="delete" size="15" name="close-window-cross" *ngIf="!element.userId" (click)="delete(element)"></app-icon>
              </div>
            </td>
          </ng-container>
          <!-- binding table header -->
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <!-- binding table row -->
          <tr mat-row *matRowDef="let element; columns: displayedColumns;"
              class="element-row"
              [class.expanded-row]="expandedElement === element"
              (click)="expandedElement = element">
          </tr>
        </table>
      </ng-container>
    </mat-tab>

    <!-- People Tab -->
    <mat-tab label="Carrier Workers">
      <div class="people-tab-header">
        <button mat-raised-button color="primary" (click)="editWorker({})">
          <mat-icon>add</mat-icon>
          New Worker
        </button>
      </div>
      <table mat-table [dataSource]="peopleDataSource" matSort class="mat-elevation-z8">
        <ng-container matColumnDef="firstName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> First Name </th>
          <td mat-cell *matCellDef="let element"> {{element.firstName}} </td>
        </ng-container>

        <ng-container matColumnDef="lastName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Last Name </th>
          <td mat-cell *matCellDef="let element"> {{element.lastName}} </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="actions-column"> Actions </th>
          <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()" class="actions-column">
            <div class="actions" *ngIf="!element.locked">
              <app-icon title="edit" class="pencil-icon" size="15" name="pencil" (click)="editWorker(element)"></app-icon>
              <app-icon title="delete" size="15" name="close-window-cross" (click)="deleteWorker(element)"></app-icon>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="peopleDisplayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: peopleDisplayedColumns;"></tr>
      </table>
    </mat-tab>

    <!-- People Tab -->
    <mat-tab label="Carrier Workers Roles">
      <div class="people-tab-header">
        <button mat-raised-button color="primary" (click)="editWorkerRole({})">
          <mat-icon>add</mat-icon>
          New Role
        </button>
      </div>
      <table mat-table [dataSource]="rolesDataSource" matSort class="mat-elevation-z8">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
          <td mat-cell *matCellDef="let element"> {{element.name}} </td>
        </ng-container>

        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Description </th>
          <td mat-cell *matCellDef="let element"> {{element.description}} </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="actions-column"> Actions </th>
          <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()" class="actions-column">
            <div class="actions" *ngIf="!element.locked">
              <app-icon title="edit" class="pencil-icon" size="15" name="pencil" (click)="editWorkerRole(element)"></app-icon>
              <app-icon title="delete" size="15" name="close-window-cross" (click)="deleteWorkerRole(element)"></app-icon>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="rolesDisplayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: rolesDisplayedColumns;"></tr>
      </table>
    </mat-tab>
  </mat-tab-group>
</div>
